import { Subject } from 'rxjs/Subject';
import * as _ from 'lodash-es';
export const subscribeOnInit = function (target, observables) {
    const ngOnInit = target.prototype.ngOnInit;
    const lookup = { getter: {}, setter: {} };
    _.each(observables, (property) => {
        lookup.getter[property] = target.prototype.__proto__.__lookupGetter__(property);
        lookup.setter[property] = target.prototype.__proto__.__lookupSetter__(property);
    });
    target.prototype.ngOnInit = function () {
        if (observables instanceof Array) {
            _.each(observables, (property) => {
                Object.defineProperty(this, `${property}$$`, { writable: false, value: new Subject() });
                Object.defineProperty(this, `${property}$`, { writable: false, value: this[`${property}$$`].asObservable() });
                Object.defineProperty(this, property, {
                    set: function (value) {
                        setTimeout(() => {
                            this[`${property}$$`].next(value);
                        }, 0);
                        if (lookup.setter[property] !== undefined) {
                            lookup.setter[property].apply(this, arguments);
                        }
                        else {
                            this[`_${property}`] = value;
                        }
                    },
                    get: function () {
                        if (lookup.getter[property] === undefined) {
                            return this[`_${property}`];
                        }
                        else {
                            return lookup.getter[property].apply(this, arguments);
                        }
                    }
                });
            });
        }
        if (ngOnInit !== undefined) {
            ngOnInit.apply(this, arguments);
        }
    };
};
//# sourceMappingURL=subscribe-on-init.func.js.map